import { useMemo } from 'react';

import { useGetStreams } from '@vlabs/api/artemy/client';
import { usePageAccess } from '@vlabs/permissions';
import { TruncatedText } from '@vlabs/shared/components/truncated-text/TruncatedText';
import { Control } from '@vlabs/uikit';
import type { WithClassNameProp } from '@vlabs/uikit/types';
import cn from 'classnames';
import { generatePath } from 'react-router-dom';

interface StreamLinkPoint3Props extends WithClassNameProp {
  streamId?: string | null;
  hideId?: boolean;
  size?: 'small' | 'medium' | 'large';
  kind?: 'primary' | 'secondary';
  hasTruncatedLink?: boolean;
  placeholders?: { removed?: string; unavailable?: string };
}

// point3-замена shared EventStreamLink (redux selectStreamOptions/viewerCan), паттерн EventInfoCellPoint3
export function StreamLinkPoint3({
  streamId = undefined,
  className = undefined,
  hideId = false,
  size = 'large',
  kind = 'primary',
  hasTruncatedLink = false,
  placeholders = {},
}: StreamLinkPoint3Props): React.JSX.Element {
  const { data: streamsList } = useGetStreams();
  const canViewStreamWatch = usePageAccess('streams_fs');
  const canViewStreamDetails = usePageAccess('stream_details');

  const stream = useMemo(
    () => streamsList?.streams?.find((s) => s.stream_id === streamId) ?? undefined,
    [streamsList, streamId],
  );

  if (!streamId) return <span>-</span>;

  if (!stream) {
    if (hideId) return <span>{placeholders.removed ?? '-'}</span>;
    return <span>{streamId}</span>;
  }

  const label = stream.name ?? stream.stream_id ?? streamId;
  if (!label) return <span>-</span>;

  if (!canViewStreamWatch && !canViewStreamDetails) {
    return <span className={cn(className)}>{label}</span>;
  }

  return (
    <Control.Link
      className={cn(className)}
      kind={kind}
      size={size}
      target="_blank"
      to={generatePath(
        canViewStreamWatch ? '/stream-watch/:streamId' : '/stream-details/:streamId',
        { streamId },
      )}
    >
      <TruncatedText
        hasTruncation={hasTruncatedLink}
        tooltipContent={label}
      >
        {label}
      </TruncatedText>
    </Control.Link>
  );
}
